import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { from } from 'rxjs';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';



interface ItemByEPc {
  data: Item[]
}

interface Item {
  ItemCuid: string,
  label: string,
  epc: string
}


@Injectable()
export class ItemKpiService {

  constructor(private http: HttpClient, private router: Router) {
  }

  getItemsAtFacility(facilityCuid?) {

    const data = {
      "data": {
        "no_items": 102,
        "no_lost_items": 102,
        "chart_data": [
          {
            "item_cuid": "cjneey1d600011vr9s3vuumcf",
            "name": "Sweat Jacket",
            "value": 24,
            "percent_lost": 0.08,
            "total_in_group": 300
          },
          {
            "item_cuid": "cjneey1d700031vr9fnnwfwtd",
            "name": "Poloshirt",
            "value": 29,
            "percent_lost": 0.07,
            "total_in_group": 400
          },
          {
            "item_cuid": "cjneey1d600021vr940kmo9oo",
            "name": "Sweat Pants",
            "value": 49,
            "percent_lost": 0.09,
            "total_in_group": 500
          }
        ]
      }
    };
  
    // Return the hardcoded data
    return of(data);
    // if (facilityCuid) {
    //   return this.http.get(environment.apiUrl + '/api/statistics/items-at-facility/' + facilityCuid);
    // } else {
    //   return this.http.get(environment.apiUrl + '/api/statistics/items-at-facility');
    // }
  }

  getItemsAtLocations(customerId?: string, filterLocationType?: string, includeUnknown?) {

    let p = {};

    if (filterLocationType) {
      p['filterLocationType'] = filterLocationType
    }

    if (includeUnknown != null) {
      p['includeUnknown'] = includeUnknown
    }

    if (customerId) {
      return this.http.get(environment.apiUrl + '/api/statistics/items-at-location?customerId=' + customerId, { params: p });
    } else {
      return this.http.get(environment.apiUrl + '/api/statistics/items-at-location', { params: p });
    }
  }
  getNoOfLostItems(limitInDays = environment.kpiParameters.itemLooseDays, filterLocationType?: string, includeUnknown?: number) {
    // Hardcoded return value
    const data = {
      "data": {
        "no_items": 102,
        "no_lost_items": 102,
        "chart_data": [
          {
            "item_cuid": "cjneey1d600011vr9s3vuumcf",
            "name": "Sweat Jacket",
            "value": 24,
            "percent_lost": 0.08,
            "total_in_group": 300
          },
          {
            "item_cuid": "cjneey1d700031vr9fnnwfwtd",
            "name": "Poloshirt",
            "value": 29,
            "percent_lost": 0.07,
            "total_in_group": 400
          },
          {
            "item_cuid": "cjneey1d600021vr940kmo9oo",
            "name": "Sweat Pants",
            "value": 49,
            "percent_lost": 0.09,
            "total_in_group": 500
          }
        ]
      }
    };
  
    // Return the hardcoded data
    return of(data);  // Assuming you are using RxJS 'of' to return an observable
  }

  // getNoOfLostItems(limitInDays = environment.kpiParameters.itemLooseDays, filterLocationType?: string, includeUnknown?: number) {
  //   let p = {};

  //   if (filterLocationType) {
  //     p['filterLocationType'] = filterLocationType
  //   }
  //   if (includeUnknown != null) {
  //     p['includeUnknown'] = includeUnknown
  //   }

  //   return this.http.get(environment.apiUrl + '/api/statistics/no-lost-items/' + limitInDays, { params: p });
  // }

  // getNoOfLostAndExistingItems(limitInDays = environment.kpiParameters.itemLooseDays, filterLocationType?: string) {
  //   let p = {};

  //   if (filterLocationType) {
  //     p['filterLocationType'] = filterLocationType
  //   }
  //   return this.http.get(environment.apiUrl + '/api/statistics/no-lost-and-existing-items/' + limitInDays, { params: p });
  // }

  getNoLostItemsPerTime(limitInDays = environment.kpiParameters.itemLooseDays, period?: string, start?: string, end?: string, filterLocationType?: string) {

    let p = {
      'period': period ? period : 'This month',
    };

    if (filterLocationType) {
      p['filterLocationType'] = filterLocationType
    }

    if (start) {
      p['start'] = start;
    }

    if (end) {
      p['end'] = end;
    }

    return this.http.get(
      environment.apiUrl + '/api/statistics/no-lost-items/' + limitInDays, { params: p });
  }

  getNoItemsOverTime(locationType, locationCuid, period?: string, start?: string, end?: string) {

    let p = {
      'period': period ? period : 'This year',
    };

    if (start) {
      p['start'] = start;
    }

    if (end) {
      p['end'] = end;
    }

    return this.http.get(
      environment.apiUrl + '/api/statistics/no-items-over-time/' + locationType + '/' + locationCuid, { params: p });
  }

  getIncomingOutgoingItemsOverTime(locationType, locationCuid, productTypeCuid, period?: string, start?: string, end?: string) {

    const p = {
      'period': period ? period : 'This year',
    };

    if (start) {
      p['start'] = start;
    }

    if (end) {
      p['end'] = end;
    }

    if (locationType && locationCuid && productTypeCuid) {
      return this.http.get(
        environment.apiUrl + '/api/statistics/incoming-outgoing-products-over-time/' + locationType + '/' + locationCuid + '/' + productTypeCuid, { params: p });
    }

    return from([]);

  }

  getNoOfLostAndExistingItems(limitInDays = environment.kpiParameters.itemLooseDays, filterLocationType?: string) {
    return of({
      data: [
        {
          name: "Sweat Jacket",
          percent_lost: 0.08,
          percent_lost_label: "Percent Lost",
          total_count: 300,
          total_count_label: "Total Items Count",
          series: [
            { name: "Lost", label: "Items Lost Count", value: 24 },
            { name: "In Circulation", label: "Items in Circulation Count", value: 276 }
          ]
        },
        {
          name: "Poloshirt",
          percent_lost: 0.073,
          percent_lost_label: "Percent Lost",
          total_count: 400,
          total_count_label: "Total Items Count",
          series: [
            { name: "Lost", label: "Items Lost Count", value: 29 },
            { name: "In Circulation", label: "Items in Circulation Count", value: 371 }
          ]
        },
        {
          name: "Sweat Pants",
          percent_lost: 0.093,
          percent_lost_label: "Percent Lost",
          total_count: 500,
          total_count_label: "Total Items Count",
          series: [
            { name: "Lost", label: "Items Lost Count", value: 49 },
            { name: "In Circulation", label: "Items in Circulation Count", value: 451 }
          ]
        }
      ]
    });
  }
  
  
  getNoOfLostItemsPerCustomer() {
    return of({
      data: [
        {
          name: "Clean Cabinets",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          series: [
            { name: "Sweat Jacket XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 2 },
            { name: "Sweat Jacket L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 1 },
            { name: "Sweat Pants S", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 1 },
            { name: "Poloshirt XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 3 },
            { name: "Sweat Pants M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 2 },
            { name: "Poloshirt S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 1 }
          ]
        },
        {
          name: "Soil Cabinets",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          series: [
            { name: "Sweat Jacket XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 1 },
            { name: "Sweat Pants L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 2 },
            { name: "Sweat Jacket S", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 1 },
            { name: "Sweat Pants XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 2 },
            { name: "Poloshirt M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 1 },
            { name: "Poloshirt S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 1 }
          ]
        },
        {
          name: "John Doe",
          cuid: "cm2xbbips0005dn43we09vfv4",
          series: [
            { name: "Sweat Jacket XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 2 },
            { name: "Sweat Jacket L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 1 },
            { name: "Sweat Pants S", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 2 },
            { name: "Poloshirt XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 1 },
            // { name: "Poloshirt M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 2 },
            { name: "Poloshirt S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 1 }
          ]
        },
        {
          name: "Jane Smith",
          cuid: "cm2xbbips0006dn43n0dezxiu",
          series: [
            { name: "Sweat Jacket XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 1 },
            { name: "Sweat Pants L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 1 },
            { name: "Sweat Pants XL", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 1 },
            { name: "Poloshirt XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 2 },
            { name: "Poloshirt M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 1 },
            { name: "Poloshirt S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 2 }
          ]
        },
        {
          name: "Emily Johnson",
          cuid: "cm2xbbips0007dn436qvuldri",
          series: [
            { name: "Sweat Jacket XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 2 },
            { name: "Sweat Jacket L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 1 },
            { name: "Sweat Jacket S", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 1 },
            { name: "Poloshirt XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 1 },
            { name: "Poloshirt M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 2 },
            { name: "Sweat Pants S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 1 }
          ]
        },
        {
          name: "Michael Brown",
          cuid: "cm2xbbips0008dn43rhhni9n5",
          series: [
            { name: "Sweat Pants XL", cuid: "cm2u95jjz000ekp43t3fy6828", value: 1 },
            { name: "Sweat Jacket L", cuid: "cm2u95jjz000gkp43ibhbd91l", value: 2 },
            { name: "Sweat Jacket S", cuid: "cm2u95jjz000hkp43fxe9aio5", value: 2 },
            { name: "Poloshirt XL", cuid: "cm2u95jjz000ikp43c3br5h8z", value: 2 },
            { name: "Poloshirt M", cuid: "cm2u95jjz000jkp43cknqtk0i", value: 1 },
            { name: "Poloshirt S", cuid: "cm2u95jjz000lkp43k0ugy401", value: 1 }
          ]
        }
      ]
      
    });
  }
  
  getTopLocationsWithLostItems() {
    return of({
      data: [
        {
          name: "Clean Cabinets",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 10
        },
        {
          name: "Soil Cabinets",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 8
        },
        {
          name: "John Doe",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 6
        },
        {
          name: "Jane Smith",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 6
        },
        {
          name: "Emily Johnson",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 8
        },
        {
          name: "Michael Brown",
          cuid: "cm1gbcxb600035x8a12q7bq5f",
          value: 9
        }
      ]
    });
  }
  

  getNoItemsPerCustomer(customerId?: string) {
    if (customerId) {
      return this.http.get(environment.apiUrl + '/api/statistics/items-per-location-per-product?customerId=' + customerId);
    } else {
      return this.http.get(environment.apiUrl + '/api/statistics/items-per-location-per-product');
    }

  }

  // getNoOfLostItemsPerCustomer(filterLocationType?: string) {
  //   let p = {};

  //   if (filterLocationType) {
  //     p['filterLocationType'] = filterLocationType
  //   }
  //   return this.http.get(environment.apiUrl + '/api/statistics/no-lost-items-per-customer', { params: p });
  // }

  // getNoOfLostItemsForLocation(locationType: string, locationCuid: string) {
  //   return this.http.get(environment.apiUrl + '/api/statistics/no-lost-items-for-location/' + locationType + '/' + locationCuid);
  // }
  getNoOfLostItemsForLocation(locationType: string, locationCuid: string) {

    const mockData = {
      "1": [
        { name: "Sweat Jacket XL", value: 2, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 2 },
        { name: "Sweat Jacket L", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
        { name: "Sweat Jacket S", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
        { name: "Poloshirt XL", value: 3, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 3 },
        { name: "Poloshirt M", value: 2, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 2 },
        { name: "Poloshirt S", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
      ],
      "2": [
        { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
      ],

      "cm2xbbips0005dn43we09vfv4": [
        // { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
        // { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket XL",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket L",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Sweat Jacket S",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt XL",  value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 3 },
        { name: "Poloshirt M",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt S",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
      ],

      "cm2xbbips0006dn43n0dezxiu": [
        // { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
        // { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket XL",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        // { name: "Sweat Jacket L",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        // { name: "Sweat Jacket S",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt XL",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt M",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Poloshirt S",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
      ],

      "cm2xbbips0007dn436qvuldri": [
        // { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
        // { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket XL",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket L",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Sweat Jacket S",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Poloshirt XL",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Poloshirt M",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt S",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
      ],

      "cm2xbbips0008dn43rhhni9n5": [
        // { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
        // { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket XL",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Sweat Jacket L",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Sweat Jacket S",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt XL",  value: 2, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 },
        { name: "Poloshirt M",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
        { name: "Poloshirt S",  value: 1, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 1 },
      ],


    

      // "5": [
      //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
      //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
      // ]
      // ,

      // "6": [
      //   { name: "Jacket L", value: 2, no_lost_items_30: 1, no_lost_items_60: 1, no_lost_items_90: 2 },
      //   { name: "Shirt M", value: 3, no_lost_items_30: 0, no_lost_items_60: 1, no_lost_items_90: 2 }
      // ]
    };

    const data = mockData[locationCuid] || [];
    return of({ data });
    // return of({
    //   data: [
    //     { name: "Sweat Jacket XL", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
    //     { name: "Sweat Jacket S", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
    //     { name: "Poloshirt M", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
    //     { name: "Poloshirt S", value: 1, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 1 },
    //     { name: "Sweat Jacket L", value: 2, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 2 },
    //     { name: "Poloshirt XL", value: 2, no_lost_items_30: 0, no_lost_items_60: 0, no_lost_items_90: 2 }
    //   ]
    // });
        }

  // getTopLocationsWithLostItems(n = 5, filterLocationType?: string) {
  //   let p = {};
  //   if (filterLocationType) {
  //     p['filterLocationType'] = filterLocationType
  //   }

  //   return this.http.get(environment.apiUrl + '/api/statistics/top-locations-with-lost-items/' + n, { params: p });
  // }

  getLocationsWithLostItems() {
    return of({
      data: [
        {
          cuid: "1",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "Clean Cabinets",
          label: "Clean Cabinets"
        },
        {
          cuid: "2",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "Soil Cabinets",
          label: "Soil Cabinets"
        },
        {
          cuid: "cm2xbbips0005dn43we09vfv4",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "John Doe",
          label: "John Doe"
        },
        {
          cuid: "cm2xbbips0006dn43n0dezxiu",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "Jane Smith",
          label: "Jane Smith"
        },
        {
          cuid: "cm2xbbips0007dn436qvuldri",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "Emily Johnson",
          label: "Emily Johnson"
        },
        {
          cuid: "cm2xbbips0008dn43rhhni9n5",
          __typename: "Facility",
          created_at: "2024-10-29T09:35:35+00:00",
          updated_at: "2024-10-29T09:35:35+00:00",
          name: "Michael Brown",
          label: "Michael Brown"
        }
      ]
    });
  }
  
  // getLocationsWithLostItems(filterLocationType?: string) {
  //   let p = {};
  //   if (filterLocationType) {
  //     p['filterLocationType'] = filterLocationType
  //   }

  //   return this.http.get(environment.apiUrl + '/api/statistics/locations-with-lost-items', { params: p });
  // }

  getEPCHistory(searchQuery:string) {
    console.log(searchQuery);
    this.getItemcuid(searchQuery).subscribe(
      (response) => {
        console.log("response");
        console.log(response);
        const item = response.data;
        console.log(item)
        if (item.length > 0) {
          console.log(item[0])
          const itemCuid = item[0].ItemCuid
          console.log(itemCuid)
          this.router.navigate([`management/items/${itemCuid}`]); 
        }
        return null;
      })
    // )
    // .subscribe(
    //   (result) => {
    //     console.log(result); // Handle the result from the final HTTP call
    //   },
    //   (error) => {
    //     console.error("Error occurred:", error); // Handle errors
    //   }
    // );
  }
  // const query = `${apiUrl}/api/identifiers/${searchQuery}/status`; // Using template literals for concatenation
  // console.log(query);
  //   // console.log(environment.apiUrl + '/identifiers/' + searchQuery + '/status');
  //   // const query = environment.apiUrl + '/identifiers/' + searchQuery + '/status';
  //   // console.log(query)
  //   return this.http.get(query);
  // }

  getItemcuid(searchQuery:string): Observable<ItemByEPc>{
    const epcData = {
      'epcs': searchQuery,
    }
    console.log(searchQuery);
    return this.http.post<ItemByEPc>(`${environment.apiUrl}/api/items-by-epc`, epcData)
  }

}
